// extracted by mini-css-extract-plugin
export default {"ModalHeader":"LpU5kNtoWVqnlYb8Ujhv","HeaderLabel":"LH9u3AZ2QsNrWOBXz4W0","ModalBody":"phgA0qUIIWZRklT1jAL4"};